import { setUrlFromState } from "../helpers/setUrlFromState";
import { Data } from "../types/Data";
import { GroupLabel } from "./GroupLabel";
import { Store } from "./Store";

export class LocationInput {
  store: Store;
  data: Data;
  label: GroupLabel;
  #debounce: any;

  constructor({
    store,
    data,
    label,
  }: {
    store: Store;
    data: Data;
    label: GroupLabel;
  }) {
    this.store = store;
    this.data = data;
    this.label = label;
    this.#initValue();
    this.#registerOnInputChange();
    this.#registerRemove();
    this.#registerOnRangeChange();
    this.#renderLabel();
  }

  #initValue() {
    const {
      "code-postal": code,
      ville,
      "localite-range": range,
    } = this.store.getState();
    if (!(code && ville)) return;
    const input = document.getElementById(
      "location-input"
    )! as HTMLInputElement;
    input.disabled = true;
    input.value = `${ville} (${code})`;
    const button = document.getElementById("location-remove")! as HTMLElement;
    button.style.display = "block";
    if (range)
      (document.getElementById("location-range")! as HTMLInputElement).value =
        range;
  }

  #registerOnInputChange() {
    const input = document.getElementById(
      "location-input"
    )! as HTMLInputElement;
    const results = document.getElementById(
      "location-search-results"
    )! as HTMLElement;
    input.addEventListener("input", async () => {
      const { value } = input;
      if (value.length < 3) {
        results.style.display = "none";
      } else {
        results.style.display = "block";
        results.innerHTML = "...";
        if (this.#debounce) {
          clearTimeout(this.#debounce);
        }
        this.#debounce = setTimeout(() => {
          this.#fetchCities(value, results);
        }, 500);
      }
    });
  }

  async #fetchCities(value: string, results: HTMLElement) {
    const cities = await (
      await fetch(`/wp-json/api/get_cities?search=${value}`)
    ).json();
    results.innerHTML = cities
      .map(
        ({ code_postal: code, name: ville }) =>
          `<div class="location-search-result">${ville} (${code})</div>`
      )
      .join("");
    (
      [
        ...document.getElementsByClassName("location-search-result"),
      ] as HTMLElement[]
    ).forEach(this.#registerOnCityClick.bind(this));
  }

  #registerOnCityClick(element: HTMLElement) {
    element.addEventListener("click", () => {
      const [ville, code] = element.innerText.split(" (");
      const input = document.getElementById(
        "location-input"
      )! as HTMLInputElement;
      input.value = `${ville} (${code.slice(0, -1)})`;
      this.store.updateState("code-postal", code.slice(0, -1));
      this.store.updateState("ville", ville);
      input.disabled = true;
      document.getElementById("location-remove")!.style.display = "block";
      document.getElementById("location-search-results")!.style.display =
        "none";
      setUrlFromState(this.store.getState());
      this.#renderLabel();
    });
  }

  #registerRemove() {
    const button = document.getElementById("location-remove")! as HTMLElement;
    button.addEventListener("click", () => {
      this.store.updateState("code-postal", "");
      this.store.updateState("ville", "");
      setUrlFromState(this.store.getState());
      const input = document.getElementById(
        "location-input"
      )! as HTMLInputElement;
      input.disabled = false;
      input.value = "";
      button.style.display = "none";
      this.#renderLabel();
    });
  }

  #registerOnRangeChange() {
    const range = document.getElementById(
      "location-range"
    )! as HTMLInputElement;
    range.addEventListener("input", () => {
      this.store.updateState(
        "localite-range",
        range.value === "0" ? undefined : range.value
      );
      setUrlFromState(this.store.getState());
      this.#renderLabel();
    });
  }

  #renderLabel() {
    this.label.refresh({
      state: this.store.getState(),
      data: this.data,
    });
  }
}
